<template>
    <modal name="state-selector-modal" height="auto" :adaptive="true">
        <div class="p-5">
            <h2 class="text-lg font-bold">Select States</h2>
            <div class="p-2 mt-4">
                <input
                    type="text"
                    v-model="searchQuery"
                    placeholder="Search..."
                    class="w-full px-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                />
            </div>
            <ul class="max-h-60 overflow-y-auto border rounded-md mt-2">
                <li
                    v-for="state in filteredStates"
                    :key="state.state"
                    @click="toggleStateSelection(state.state)"
                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
                >
                    <input
                        type="checkbox"
                        :checked="localSelectedStates.includes(state.state)"
                        class="mr-3 form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out pointer-events-none"
                    />
                    <span>{{ state.name }}</span>
                </li>
            </ul>
            <div class="mt-4 flex justify-end gap-x-2">
                 <button @click="cancel" class="px-4 py-2 bg-gray-200 text-gray-800 font-semibold rounded-md hover:bg-gray-300">
                    Cancel
                </button>
                <button @click="saveSelection" class="px-4 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700">
                    Save
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        selectedStates: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localSelectedStates: [...this.selectedStates],
            searchQuery: '',
        };
    },
    computed: {
        ...mapState(['reatlas']),
        availableStates() {
            return _.sortBy(this.reatlas.states, 'name') || [];
        },
        filteredStates() {
            if (!this.searchQuery) {
                return this.availableStates;
            }
            return this.availableStates.filter(state =>
                state.name && state.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    methods: {
        toggleStateSelection(stateCode) {
            const index = this.localSelectedStates.indexOf(stateCode);
            if (index > -1) {
                this.localSelectedStates.splice(index, 1);
            } else {
                this.localSelectedStates.push(stateCode);
            }
        },
        saveSelection() {
            this.$emit('update:selectedStates', this.localSelectedStates);
            this.$modal.hide('state-selector-modal');
        },
        cancel() {
            this.$modal.hide('state-selector-modal');
        },
    },
    watch: {
        selectedStates(newVal) {
            this.localSelectedStates = [...newVal];
        },
    },
};
</script>
